import * as turf from '@turf/turf';
export var getFeatures = function getFeatures(geojson) {
  var markerPoints = {};
  turf.featureEach(geojson, function (currentFeature) {
    return turf.featureEach(currentFeature, function (feature) {
      var properties = feature.properties;

      // Get markers coordinates.
      return turf.geomEach(feature, function (currentGeometry) {
        var featureType = properties.type || 'Other';
        var multiPoint = turf.getType(currentGeometry) === 'MultiPoint';
        var coordinates = turf.getCoords(currentGeometry);
        if (!Object.keys(markerPoints).includes(featureType)) {
          markerPoints[featureType] = [];
        }
        markerPoints[featureType].push({
          coordinates: multiPoint ? coordinates : [coordinates],
          properties: properties
        });
      });
    });
  });
  return markerPoints;
};
export function decodeHTMLEntities(text) {
  var entities = {
    amp: '&',
    apos: "'",
    '#x27': "'",
    '#x2F': '/',
    '#39': "'",
    '#47': '/',
    lt: '<',
    gt: '>',
    nbsp: ' ',
    quot: '"'
  };
  return JSON.parse("\"".concat(text, "\"")).replace(/&([^;]+);/gm, function (match, entity) {
    return entities[entity] || match;
  });
}